import React from 'react';
import { useRouter } from 'next/router';
import CompanyPageComponent from '@/components/CompanyPage/desktop';
import CompanyPageMetaHeader from './header';
import { useAppSelector } from '@/utils/hook';

interface IState {
  [key: string]: any;
}

export const AIRLINES: IState = {
  'vietnam-airlines': {
    type: 'VN',
    name: 'Vietnam Airlines',
    img: 'https://vanphongvemaybay.vn/wp-content/uploads/Vietnam-Airlines-Office-Banner.jpg',
    slug: 'vietnam-airlines',
  },
  'vietjet-air': {
    type: 'VJ',
    name: 'Vietjet Air',
    img: 'http://lamnguyentravel.com/public/uploads/images/images/VJ%20quang%20cao.gif',
    slug: 'vietjet-air',
  },
  'bamboo-airways': {
    type: 'QH',
    name: 'Bamboo Airways',
    img: 'https://d3jyiu4jpn0ihr.cloudfront.net/wp-content/uploads/sites/6/20190119120151/thumbnail-facebook.jpg',
    slug: 'bamboo-airways',
  },
  'vietravel-airlines': {
    type: 'VU',
    name: 'Vietravel Airlines',
    img: 'https://upload.wikimedia.org/wikipedia/commons/e/ee/Vietravel_Airlines_Logo.png',
    slug: 'vietravel-airlines',
  },
  'pacific-airlines': {
    type: 'BL',
    name: 'Pacific Airlines',
    img: 'https://storage.googleapis.com/goyolo-production/logo-pacific-airlines.jpeg',
    slug: 'pacific-airlines',
  },
};
function CompanyPageContainer({ company, countSeoResult }: { company?: string, countSeoResult: any }) {
  const router = useRouter();
  const branchPage: IState = AIRLINES[company || ''];
  const headerTabs = useAppSelector((state) => state.headerTabs || 0);

  if (company && !branchPage) {
    router.push('/');
    return <div />;
  }
  let path = process.env.GOYOLO_URL + router.asPath;
  if (typeof window !== 'undefined') {
    path = window.location.href;
  }
  return (
    <>
      <CompanyPageMetaHeader
        branchPage={branchPage}
        path={path}
      />
      <CompanyPageComponent
        headerTabs={headerTabs}
        branchPage={branchPage}
        countSeoResult={countSeoResult}
      />
    </>
  );
}

export default CompanyPageContainer;
